// Cabinet store names
export const TICKETS_STORE = 'tickets'
export const ORDER_DETAILS_STORE = 'orderDetails'
export const ADDRESS_BOOK_STORE = 'addressBook'
export const DOCUMENTS_STORE = 'documents'
export const FAV_COURIERS_STORE = 'favCouriers'
export const NEWS_STORE = 'news'
export const ORDERS_LIST_STORE = 'ordersList'
export const PICKUP_STORE = 'pickup'
export const EXTRA_USER_DETAILS_STORE = 'extraUserDetails'
export const TARIFFS_STORE = 'tariffs'
export const TEMPLATE_STORE = 'templatePage'
export const ADD_BALANCE_STORE = 'addBalance'
export const ADD_BALANCE_HISTORY_STORE = 'addBalanceHistory'
export const CASH_SERVICE_STORE = 'cashService'
export const WITHDRAWAL_STORE = 'withdrawal'
export const CASH_HISTORY_STORE = 'cashHistory'
export const STAFF_COURIERS_STORE = 'staffCouriers'
export const STATEMENT_STORE = 'statement'
export const ORDERS_FILTER_STORE = 'ordersFilter'
